import { BodyText, Checkbox } from '@policygenius/mortar';
import React from 'react';
import { useField } from 'react-final-form';

import MaskedTextField from 'components/formInputs/MaskedTextField';
import { formattedNumberMask } from 'components/formInputs/MaskedTextField/masks';
import ShowHide from 'components/ShowHide';
import { parseInteger } from 'forms/parsers';

const SpousalQuoteInfo = () => {
  const {
    input: { value: spouseOrPartner },
  } = useField('spouseOrPartner');
  const {
    input: { value: spouseAnnualIncome },
  } = useField('spouseAnnualIncome');
  const {
    input: { value: childrenOrPlanTo },
  } = useField('childrenOrPlanTo');
  const { input } = useField<boolean>('spousalQuotesRequested', {
    initialValue: false,
  });

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => input.onBlur(e);
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => input.onFocus(e);

  const spouseHasIncome = spouseAnnualIncome && Number.parseInt(spouseAnnualIncome, 10) > 0;

  const getSpousalNudgeCopy = () => {
    if (spouseHasIncome && !childrenOrPlanTo) {
      return "For couples, we recommend that each spouse get coverage to ensure total financial protection. Don't worry — it can be pretty affordable.";
    }
    if (spouseHasIncome && childrenOrPlanTo) {
      return "For couples who either have children or plan to, we recommend that each spouse get coverage to ensure total financial protection. Don't worry — it can be pretty affordable.";
    }
    if (!spouseHasIncome && childrenOrPlanTo) {
      return "Just a heads up: For couples with children, we recommend that each spouse get coverage to ensure total financial protection. While your spouse may not earn an income, a small policy on them could cover childcare costs. Don't worry — it can be pretty affordable.";
    }

    return null;
  };

  const spousalNudgeCopy = getSpousalNudgeCopy();

  if (!spouseOrPartner) {
    return null;
  }

  return (
    <>
      <MaskedTextField
        name="spouseAnnualIncome"
        label="What is your spouse or partner’s individual income?"
        maskOptions={formattedNumberMask}
        prefix="$"
        config={{ parse: parseInteger }}
        inputMode="numeric"
      />
      <ShowHide visible={!!spousalNudgeCopy}>
        <div>
          <BodyText style={{ fontSize: '1.125rem', marginBottom: '1rem' }}>
            <strong>Just a heads up: </strong>
            {spousalNudgeCopy}
          </BodyText>
          <Checkbox
            label="I'd like more information about quotes for my spouse"
            name={input.name}
            value="spousalQuotesRequested"
            checked={input.value}
            onChange={(e) => input.onChange(e.target.checked)}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
        </div>
      </ShowHide>
    </>
  );
};

export default SpousalQuoteInfo;
